export default __webpack_public_path__ + "static/media/miniatura7.377415f5.jpg";